<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.pushContent" placeholder="推送内容"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getInfos">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="infos" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="target_type_name" label="推送对象"  width="100">
			</el-table-column>
			<el-table-column prop="push_type_name" label="推送类型"  width="100">
			</el-table-column>
			<!-- <el-table-column prop="group_name" label="产品组"  width="80">
			</el-table-column>
			<el-table-column prop="app_name" label="产品"  width="80">
			 </el-table-column>-->
			 <el-table-column prop="title" label="标题" width="120" >
			 </el-table-column>
			<el-table-column prop="content" label="消息内容" width="120" >
			</el-table-column>
			<el-table-column prop="open_type_name" label="打开类型" width="150" >
			</el-table-column>
			<el-table-column prop="maker_name" label="创建人" width="80" >
			</el-table-column>
			<el-table-column prop="make_date" label="创建时间" width="180" >
			</el-table-column>
			<el-table-column label="操作" min-width="140">
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[20, 50, 80, 100]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false"  size="small">
			<el-form :model="editForm"    label-width="100px" :rules="editFormRules" ref="editForm">
          
			   <el-form-item label="推送对象" prop="target_type" >
					<el-select v-model="editForm.target_type"  placeholder="请选择"  style="width:400px;">
                        <el-option  v-for="(item,index) in targets" :key="index" :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				</el-form-item>
			
				   <el-form-item label="推送类型" prop="push_type">
					 <el-select v-model="editForm.push_type"  placeholder="请选择" style="width:400px;">
                        <el-option  v-for="(item,index) in pushTypes" :key="index" :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				   </el-form-item>

				   	<el-form-item label="产品组" prop="app_group">
					 <el-select v-model="editForm.app_group"  multiple  placeholder="请选择" @change="appGroupChange"   @visible-change="visibleChange" @remove-tag="removeTag" style="width:400px;">
                        <el-option  v-for="(item,index) in appgroups" :key="index" :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
					
				   </el-form-item>


				   	<el-form-item label="产品" prop="app_id">
					 <el-select v-model="editForm.app_id"  multiple   placeholder="请选择"  style="width:400px;">
                        <el-option  v-for="(item,index) in apps" :key="index" :label="item.app_name"  :value="item.id"> </el-option>
                     </el-select>
					 
				   </el-form-item>
			
				
				<el-form-item label="标题" prop="title">
					<el-input v-model="editForm.title" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="消息内容" prop="content">
				     <el-input type="textarea"  :rows="2" v-model="editForm.content" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="打开类型" prop="open_type" >
				     	<el-select v-model="editForm.open_type"  placeholder="请选择"  @change="openTypeChange" style="width:400px;">
                        <el-option  v-for="(item,index) in openTypes" :key="index" :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				</el-form-item>
				<el-form-item label="网址" prop="url" v-if="editForm.open_type=='01'"   :rules="[{ required: this.editForm.open_type=='01',  message: '请输入网址', trigger: 'blur'},
				{  type:'url', message: '请输入正确的网址格式', trigger: 'blur'}]">
				     <el-input v-model="editForm.url" auto-complete="off" ></el-input>
				</el-form-item>

				<el-form-item label="跳转页" prop="jump" v-if="editForm.open_type=='02'" >
				     	<el-select v-model="editForm.jump"  placeholder="请选择" @change="jumpChange"  style="width:400px;">
                        <el-option  v-for="(item,index) in jumps" :key="index" :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				</el-form-item>
				
				<el-form-item v-if="editForm.open_type=='02'"  v-for="(item, index) in editForm.jump_params" :key="index">
				<el-col :span="6">
						<el-form-item :label="'参数名' + (index+1)" label-width='70px' >				
							<el-input v-model="item.param_name" disabled auto-complete="off" style="width:120px;" ></el-input>					
						</el-form-item>
				</el-col>
				<el-col :span="7">
						<el-form-item :prop="'jump_params.' + index + '.param_value'" :label="'参数值'+ (index+1)" label-width='80px' :rules="{ required:editForm.open_type=='02',message: '请录入参数值', trigger:'blur'}">				
								<el-input v-model="item.param_value" auto-complete="off"  style="width:120px;"></el-input>					
						</el-form-item>
				</el-col>
				</el-form-item>
			
                  
				<el-form-item label="发送范围"  >			
                 <el-tabs v-model="editForm.send_type" @tab-click="handleClick">
					<el-tab-pane label="按用户" name="0"> 					
					  <el-radio-group v-model="editForm.user_type" >
						<el-radio :label="0">所有人</el-radio>
						<el-radio :label="1">指定用户</el-radio>						
				      </el-radio-group>				
					   
					    <el-form-item prop="users"  v-if="editForm.user_type==1" style="margin-bottom:22px;"  :rules="{ required:editForm.user_type==1,message: '请录入标识', trigger:'blur'}" ref="users">	
					          <el-input type="textarea"  :rows="2" v-model="editForm.users" auto-complete="off" placeholder="请填写用户的PUShID，多个用英文逗号分隔"></el-input>
				        </el-form-item>
					</el-tab-pane> 
					<el-tab-pane label="按标签" name="1">    			            
					  <el-form-item  v-for="(item, index) in editForm.tags" :key="index" :label="'标签信息' + (index+1)" style="margin-bottom:22px;"  @click.native="getIndex(index)"  >					    
						<el-col :span="5">
							<el-form-item  :prop="'tags.' + index + '.tag_key'" :rules="{ required:yz,message: '请选择标分类', trigger:'change'}">
									<el-select v-model="item.tag_key"  placeholder="请选择标签分类"  @change="tagKeyChange"  @visible-change="visibleChange">
											<el-option  v-for="(tagkey,i) in tags" :key="i" :label="tagkey.name"  :value="tagkey.value"> </el-option>
									</el-select>
							</el-form-item>
						</el-col>
						
						<el-col :span="8" style="margin-left:4px;" >
						<el-form-item  :prop="'tags.' + index + '.tag_value'" :rules="{required:yz, message: '请录入标签值', trigger:'change'}">							
								<el-select v-model="item.tag_value"  placeholder="请选择标签值" >
									  <el-option  v-for="(tagvalue,j) in tagvalues[index]" :key="j" :label="tagvalue.value"  :value="tagvalue.value" > </el-option>
								</el-select>								
						</el-form-item>
						</el-col>
						<el-col :span="4" style="margin-left:4px;" >
						<el-button @click.prevent="removeItem(item)" v-if="index>0">删除</el-button>
						
						</el-col>
						</el-form-item>
						 <div style="margin-left:220px;">
	                          <el-button @click.prevent="addItem()" >添加标签</el-button> 
						</div>
			
                      
				    
				   </el-tab-pane>
					
				</el-tabs>


			</el-form-item>

		
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelSubmit">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

	
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getPushListPage,addPush,editPush, removePush,batchRemovePush,getTags,getTagValues,getJump,getJumpParams,getAppGroup,getApp,getPushBase } from '../../api/api';
 
 let CurrentUserID="",Session=""; 
 let tagvaluestmp=[];
	export default {
		data() {
			return {
				filters: {
					pushContent: ''
				},
			
				selectchangeflag:0,
				tagIndex:0,
				tags:[],
				appgroups:[],
				apps:[],
				tagvalues:[],		
				targets:[],//[{item_value:'0',item_name:'全部'},{item_value:'1',item_name:'Android'},{item_value:'2',item_name:'IOS'}],
				pushTypes:[],// [{item_value:'01',item_name:'系统推送'},{item_value:'02',item_name:'资讯推送'},{item_value:'03',item_name:'活动推送'},{item_value:'04',item_name:'产品推送'}],
				openTypes:[],//[{item_value:'01',item_name:'内置浏览器打开'},{item_value:'02',item_name:'内部页面打开'}],
				jumps:[],				
				infos: [],
				total: 0,
				pageSize:20,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					content: [
						{ required: true, message: '请输入消息内容', trigger: 'blur' }
					],
					url:[ { type: 'url', message: '请输入正确的网址', trigger: 'blur' }]
					,
					title:[ {  required: true, message: '请输入标题', trigger: 'blur' }]
					
				},
				//编辑界面数据
				editForm: {
					id: 0,
					target_type: '0',					
					push_type:'01',
					title:'',
					content:'',
					open_type:'01',
					url:'',
					user_type:0,
					send_type:'0',
					users:'',
					tags:[{tag_key:'',tag_value:''}],
					jump:'',
					jump_params:[],
					app_group:[],
					app_id:[]
             
				},
				
                yz:false,

				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
			cancelSubmit:function(){
               this.editFormVisible = false;			 
			},
		getIndex(val){
                   this.tagIndex=val;
				
                },
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getInfos();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getInfos();
			},
			    handleClick(tab, event) {
					
                    this.editForm.send_type=tab.name;
				
					if (tab.name=="0")
					{
						this.$set(this.editForm,"tags",[{tag_key:'',tag_value:''}]);
                        this.yz=false;
					}
					else{
						this.editForm.users='';
						this.yz=true;
					}
					 
                },
				openTypeChange(val)
				{
				   if (this.formStatus==0)
				   {
                      this.editForm.url='';
					  this.editForm.jump='';
					  this.editForm.jump_params=[];
				   }
				   
				},
				jumpChange(val)
				{
				   				
				   this.$http.jsonp(getJumpParams,{params: {CurrentUserID:CurrentUserID,Session:Session,Jump:val }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
             			this.editForm.jump_params=res.data.jumpparams;
					}
					else{                           
						this.$message({
						message:'获取参数错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取参数错误',
								type: 'error'
								});
						
					});
				   
				},
				appGroupChange(val)
				{
					this.app_groups=val.join(',')
                      if (this.selectchangeflag==0) return;
					
						this.apps=[];
						this.editForm.app_id=[];
					if (val=='') return;				
			      
				   this.getApp(val.join(','));
				},
	
             getApp(val)
			 {
                   	   this.$http.jsonp(getApp,{params: {CurrentUserID:CurrentUserID,Session:Session,appGroup:val }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
             			this.apps=res.data.apps;
						 if (this.apps.length==0)
						 {
							 this.editForm.app_id=[];
						 }
					}
					else{                           
						this.$message({
						message:'获取产品错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取产品错误',
								type: 'error'
								});
						
					});
			 },
			 removeTag(val)
			  {
                  this.selectchangeflag=1;
			  },
              visibleChange(val)
			  {
                 if(val)
				 {
                      this.selectchangeflag=1;
				 }else{
                       this.selectchangeflag=0;
				 }
			  },
				tagKeyChange(val)
				{		


					
		             if (val=='' || this.selectchangeflag==0)
					{					
                       return;
					}

				   this.$set(this.tagvalues,this.tagIndex,[]);

				   this.$set(this.editForm.tags,this.tagIndex,{tag_key:val,tag_value:''});	
                    						 
				  			
				   this.$http.jsonp(getTagValues,{params: {CurrentUserID:CurrentUserID,Session:Session,filedName:val }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{				
						
             			this.$set(this.tagvalues,this.tagIndex,res.data.tagvalues);
					}
					else{                           
						this.$message({
						message:'获取标签值错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取标签值错误',
								type: 'error'
								});
						
					});


				},

				tagKeyQuery(val,index)
				{			
					
		             if (val=='')
					{					
                       return;
					}

				   this.$set(this.tagvalues,index,[]);				  
				
				   this.$http.jsonp(getTagValues,{params: {CurrentUserID:CurrentUserID,Session:Session,filedName:val }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{				
						
             			this.$set(this.tagvalues,index,res.data.tagvalues);
					}
					else{                           
						this.$message({
						message:'获取标签值错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取标签值错误',
								type: 'error'
								});
						
					});


				},

		   getTags(){
             	 this.$http.jsonp(getTags,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						this.tags=res.data.tags;					
					}
					else{                           
						this.$message({
						message:'获取上级菜单错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取上级菜单错误',
								type: 'error'
								});
						
					});


			},
			 getJump(){
             	 this.$http.jsonp(getJump,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						this.jumps=res.data.jumps;					
					}
					else{                           
						this.$message({
						message:'获取跳转页失败',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取跳转页失败',
								type: 'error'
								});
						
					});


			},
		   getAppGroup(){
             	 this.$http.jsonp(getAppGroup,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						this.appgroups=res.data.appgroups;					
					}
					else{                           
						this.$message({
						message:'获取产品组错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取产品组错误',
								type: 'error'
								});
						
					});


			},
			getBase(){
             	 this.$http.jsonp(getPushBase,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						this.targets=res.data.targets;	
						this.pushTypes=res.data.pushTypes;	
						this.openTypes=res.data.openTypes;					
					}
					else{                           
						this.$message({
						message:'获取基础信息错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取基础信息错误',
								type: 'error'
								});
						
					});


			},

		removeItem(item) {
        var index = this.editForm.tags.indexOf(item)
        if (index !== -1) {
          this.editForm.tags.splice(index, 1)
        }
      },
      addItem() {
		  if (this.editForm.tags.length<5)
		  {
			this.editForm.tags.push({
			tag_key: '',
			tag_value: ''
			});
		  }
      },
			
			getInfos() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					pushContent: this.filters.pushContent,					
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getPushListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.pushlist.total;
					         this.infos = res.data.pushlist.infos;
					         this.listLoading = false;
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   }
           )

			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };


                   this.$http.jsonp(removePush, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				
				this.formStatus=1;
				

				
				
				this.selectchangeflag=0
				this.editForm = Object.assign({}, row);  				
				this.$set(this.editForm,"tags",JSON.parse(row["tags"]));
				this.$set(this.editForm,"jump_params",JSON.parse(row["jump_params"]));
				this.editForm.app_group=JSON.parse(row["app_group"]);
				this.editForm.app_id=JSON.parse(row["app_id"]);	
				this.getApp(this.editForm.app_group.join(','));
               this.editFormVisible = true;
 
			for (var i=0;i<this.editForm.tags.length;i++)
			{
				  
				if (this.editForm.tags[i].tag_key!="")
				{
					
					this.tagKeyQuery(this.editForm.tags[i].tag_key,i);
					
				}

				
			}

			
				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				this.editFormVisible = true;
				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				this.editForm = {
					id: 0,
					target_type: '0',					
					push_type:'01',
					title:'',
					content:'',
					open_type:'01',
					url:'',
					user_type:0,
					send_type:'0',
					users:'',
					tags:[{tag_key:'',tag_value:''}],
					jump:'',
					jump_params:[],
				    app_group:[],
					app_id:[]
				};
           
				
			},
			//编辑
			editSubmit: function () {

				if (this.editForm.app_group.length==0||this.editForm.app_id.length==0)
				{
				    this.$message({
                                message:'请选择产品组和产品',
                                type: 'error'
                              });
							  return;
			     }
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							
                  
                          if (this.editForm.open_type!='01')
						  {
                                this.editForm.url='';
						  }
				   

							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;
							para["tags"]=JSON.stringify(this.editForm.tags);
							para["jump_params"]=JSON.stringify(this.editForm.jump_params);
							para["app_group"]=JSON.stringify(this.editForm.app_group);
							para["app_id"]=JSON.stringify(this.editForm.app_id);

			   let infoUrl=	addPush;			  
               if (this.formStatus==1)
			   {
                  infoUrl=editPush;
			   }
                //this.$http.jsonp(infoUrl, {params: para}).then(
				this.$http.post(infoUrl, para,{emulateJSON:false}).then(
                   function(res){                         
                         if (res.data.result_code==200 || res.data.result_code==1000)
                         {		
							 	this.editForm = {
								id: 0,
								target_type: '0',					
								push_type:'01',
								title:'',
								content:'',
								open_type:'01',
								url:'',
								user_type:0,
								send_type:'0',
								users:'',
								tags:[{tag_key:'',tag_value:''}],
								jump:'',
								jump_params:[],
								app_group:[],
								app_id:[]
							};
           
							 if (this.$refs['editForm'] !== undefined) {						
								this.$refs['editForm'].resetFields();
							}	
							 this.editForm.users='';				    
							 	this.editLoading = false;	
								 if(res.data.result_code==200)	
								 {						
									this.$message({
										message: '提交成功',
										type: 'success'
									});
								 }
								 else{
                                    this.$message({
										message: '提交成功,但访问发送接口失败',
										type: 'success'
									});

								 }
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getInfos();
                            
                         }
                         else{                           
                               this.editLoading = false;

					
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
							  this.editLoading = false;	
                      
                   }
           )


						});
					}
				});
			},

			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getInfos();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };


                   this.$http.jsonp(batchRemovePush, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
			this.getTags();
			this.getJump();
			this.getAppGroup();
			this.getBase();
			this.getInfos();
		
           
 	        
			
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// pushinfo.vue?538c5eaa